import React from 'react';
import { GroupLabel } from 'components/MenuList';
import useUniqueId from 'hooks/useUniqueId';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var MenuItemGroup = function MenuItemGroup(_ref) {
  var label = _ref.label,
    id = _ref.id,
    children = _ref.children;
  var uniqueId = useUniqueId(id);
  return /*#__PURE__*/_jsxs("div", {
    "aria-labelledby": uniqueId,
    role: "group",
    children: [/*#__PURE__*/_jsx(GroupLabel, {
      id: uniqueId,
      children: label
    }), children]
  });
};
export default MenuItemGroup;